import script from "./LangSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./LangSwitch.vue?vue&type=script&setup=true&lang=js"

import "./LangSwitch.vue?vue&type=style&index=0&id=1f2a1644&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/192.255.151.37/new/tiempos-h55/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2a1644"]])

export default __exports__